<template>
  <div class="Page">
    <ClientOnly>
      <Order genre="pokemon"/>
    </ClientOnly>
  </div>
</template>

<script lang="ts">
import { useSeoMeta, definePageMeta, useHead, useRuntimeConfig } from '#imports'
import { defineNuxtComponent } from '#app'
import Order from '@/containers/Order'

export default defineNuxtComponent({
  components: {
    Order
  },
  setup() {
    const { public: { APP_ENV, GMO_TOKEN_SCRIPT_ENDPOINT } } = useRuntimeConfig()
    const title = '購入 - カーナベル'
    useSeoMeta({
      title,
      ogTitle: title,
      robots: APP_ENV==='production' ? 'noindex,follow' :'noindex,nofollow',
      twitterSite: '@ka_nabell_pcg',
      ogSiteName: 'ポケカ販売ならカーナベル！',
      ogUrl: 'https://sell.ka-nabell.com/pokemon/order/'
    })
    useHead({
      script: [
        {
          // Reference: https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/#disable-implicit-rendering
          src: 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit',
          async: true
        },
        {
          src: GMO_TOKEN_SCRIPT_ENDPOINT,
          defer: true
        }
      ]
    })

    definePageMeta({
      genre: 'pokemon',
      middleware: ['auth'],
      layout: 'simple'
    })
  }
})
</script>

<style scoped>
.Page {
  width: 100%;
  padding: 20px 16px 48px;
}
</style>
